import { inject, Injectable, Provider } from '@angular/core';
import { CustomTextGetQuery, CustomTextGetQueryResult, ECustomTextType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ICustomTextApiService, ICustomTextApiServiceToken } from '../../api/custom-text/custom-text-api-service.interface';
import { ICustomTextService, ICustomTextServiceToken } from './custom-text-service.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomTextService implements ICustomTextService {
  private readonly customTextApiService: ICustomTextApiService;

  public constructor() {
    this.customTextApiService = inject(ICustomTextApiServiceToken);
  }

  public async customTextGet(customTextType: ECustomTextType, group: string, name: string): Promise<CustomTextGetQueryResult> {
    let customTextGetQuery: CustomTextGetQuery = new CustomTextGetQuery();
    customTextGetQuery.customTextType = customTextType;
    customTextGetQuery.group = group;
    customTextGetQuery.name = name;

    return await this.customTextApiService.swagCustomTextGet(customTextGetQuery);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CustomTextServiceProvider: Provider[] = [
  { provide: ICustomTextServiceToken, useExisting: CustomTextService }
];
